import * as React from 'react';
export default <svg xmlns='http://www.w3.org/2000/svg' height='20' width='20'>
    <path d='M6.5 15L10 11.5L13.5 15L15 13.5L11.5 10L15 6.5L13.5 5L10 8.5L6.5 5L5 6.5L8.5 10L5 13.5L6.5 15M0 10A10 10 0 1 1 20 10A10 10 0 1 1 0 10Z' fill='currentColor' />
</svg>